/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-webkit-box-flex:1;flex:1}[_nghost-%COMP%]   .unitIndexContainer[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .unitIndexContainer[_ngcontent-%COMP%]   .unitIndexIFrame[_ngcontent-%COMP%]{border:0;width:100%;height:100%}  .tablist-container{display:none}  .social-footer h3{padding-right:2.5rem!important}"];
export { styles as styles };
//# sourceMappingURL=unit-index-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/unit-index/unit-index-page/unit-index-page.component.scss.shim.ngstyle.js
// module id = 1654
// module chunks = 26 27 28